<!-- 威凯打印销售单模板 -->
<template>
    <div v-loading="loading" style="position: relative">
        <div id="printContent" class="print-zone">
            <div class="print-title-view">
                <div class="order-code">
                    <canvas id="canvas" class="qrcode-canvas" ref="canva"></canvas>
                    <img class="qrcode-image" :src="imgUrl" v-if="imgUrl" />
                </div>
                <div v-if="isEditTitle" class="print-title">
                    <el-input type="text" v-model="titleConfig.RValue" style="width: 200px"></el-input>
                </div>
                <div v-else class="print-title">{{ orderData.IsHaveTitleSet ? orderData.OrderTitle : titleConfig.RValue  }}</div>
                <div class="order-detail">
                    <div class="right">单号：{{ orderData.OrderCode }}</div>
                    <div class="right">
                        日期：
                        <el-date-picker
                            v-show="isEditOpenTime"
                            v-model="orderData.CreateTime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetime"
                            size="small"
                            placeholder="选择日期时间"
                        ></el-date-picker>
                        <span v-show="!isEditOpenTime">{{ orderData.CreateTime }}</span>
                    </div>
                </div>
            </div>
            <div class="print-table-main">
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 20%">客户名称</div>
                    <div class="div-table-cell fdzt" style="width: 80%">{{ orderData.EntpCusName }}</div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 20%">客户地址</div>
                    <div class="div-table-cell" style="width: 80%">{{ orderData.FullAddress }}</div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 6%">序号</div>
                    <div class="div-table-cell" style="width: 33%">汽配编码</div>
                    <div class="div-table-cell" style="width: 33%">配件名称</div>
                    <div class="div-table-cell" style="width: 6%">数量</div>
                    <div class="div-table-cell" style="width: 10%">售价</div>
                    <div class="div-table-cell" style="width: 12%">销售总价</div>
                </div>
                <div class="div-table-row" v-bind:key="index" v-for="(AP, index) in orderData.DetailList">
                    <div class="div-table-cell" style="width: 6%">
                        {{ Number(index) + 1 }}
                    </div>
                    <div class="div-table-cell" style="width: 33%">{{ AP.APCode }}</div>
                    <div class="div-table-cell" style="width: 33%">{{ AP.GoodName }}</div>
                    <div class="div-table-cell fdzt" style="width: 6%">{{ AP.Count }}</div>
                    <div class="div-table-cell" style="width: 10%">{{ AP.Price }}</div>
                    <div class="div-table-cell fdzt" style="width: 12%">{{ (AP.Count * AP.Price).toFixed(2) }}</div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 6%"></div>
                    <div class="div-table-cell" style="width: 33%"></div>
                    <div class="div-table-cell pall-count" style="width: 33%">合计 &nbsp;</div>
                    <div class="div-table-cell" style="width: 6%">{{ allNum }}</div>
                    <div class="div-table-cell" style="width: 10%"></div>
                    <div class="div-table-cell" style="width: 12%">{{ (allPrice + orderData.ShipAmount).toFixed(2) }}</div>
                </div>
            </div>
            <div class="order-remark">
                <div style="width: 16.66667%">运费：{{ orderData.ShipAmount }}</div>
                <div style="width: 25%">支付方式：{{ orderData.PayTypeName }}</div>
                <div style="width: 25%">发货方式：{{ orderData.ShipTypeName }}</div>
                <div style="width: 16.66667%">业务员：{{ nameConfig ? (orderData.SNickName ? orderData.SNickName : orderData.SName) : orderData.SName }}</div>
                <div style="width: 16.66667%">备货员：</div>
            </div>
            <div class="order-remark" v-if="orderData.Remark">
                <div>备注：{{ orderData.Remark }}</div>
            </div>
            <!--    脚注    -->
            <div class="order-remark" v-if="(config == null ? false : config.Result && !isEditConfig)|| orderData.IsHaveTitleSet">{{ orderData.IsHaveTitleSet ? orderData.FootNote : config.RValue }}</div>
            <div class="order-setcontent" v-if="isEditConfig">
                <el-input type="textarea" resize="auto" rows="3" v-model="config.RValue"></el-input>
            </div>
        </div>
        <div class="dialog-footer">
            <div class="flex">
                <!--   标题   -->
                <div class="re-set">
                    <el-button class="btn-primary" size="small" @click="isEditTitle = true" v-if="titleConfig == null ? false : titleConfig.Result && !isEditTitle&& !orderData.IsHaveTitleSet">编辑标题</el-button>
                    <el-button class="btn-primary" size="small" @click="submitTitleConfig()" v-if="isEditTitle">保存标题</el-button>
                </div>
                <!--   脚注   -->
                <div class="re-set">
                    <el-button class="btn-primary" size="small" @click="setConfig()" v-if="config == null ? false : config.Result && !isEditConfig && !orderData.IsHaveTitleSet">编辑脚注</el-button>
                    <el-button class="btn-primary" size="small" @click="submitConfig()" v-if="isEditConfig">保存脚注</el-button>
                </div>
                <!--   开单时间   -->
                <div class="open-time">
                    <el-button class="btn-primary" size="small" @click="setOpenTime()" v-if="openTimeConfig && openTimeConfig.Result && !isEditOpenTime">设置开单时间</el-button>
                    <el-button class="btn-primary" size="small" @click="submitOpenTime()" v-if="isEditOpenTime">保存开单时间</el-button>
                </div>
                <div class="sort-set">
                    <el-button class="btn-primary" size="small" @click="setSortField('sortnum')">原始排序</el-button>
                    <el-button class="btn-primary" size="small" @click="setSortField('code')">编码排序</el-button>
                    <el-button class="btn-primary" size="small" @click="setSortField('shelfspace')">仓位排序</el-button>
                </div>
            </div>
            <div v-if="printType == 1 && !isEditConfig && !isEditTitle" class="re-submit">
                <el-button class="btn-primary" size="small" v-print="'#printContent'" @click="returnOrderList(true)" v-if="isDefaultSet">打印并返回列表</el-button>
                <el-button class="btn-primary" size="small" v-print="'#printContent'" @click="continueToOrder()" v-if="isDefaultSet">打印并继续开单</el-button>
                <el-button size="small" @click="returnOrderList(false)" v-if="isDefaultSet">返回列表</el-button>
                <el-button class="btn-primary" size="small" @click="returnOrderList(true)" v-if="!isDefaultSet">打印并返回列表(F1)</el-button>
                <el-button class="btn-primary" size="small" @click="continueToOrder()" v-if="!isDefaultSet">打印并继续开单(F2)</el-button>
                <el-button size="small" @click="returnOrderList(false)" v-if="!isDefaultSet">返回列表(F3)</el-button>
            </div>
            <div v-else-if="!isEditConfig && !isEditTitle" class="re-submit">
                <el-button class="btn-primary" size="small" @click="lodopPrint" v-if="!isDefaultSet">打印</el-button>
                <el-button class="btn-primary" size="small" @click="printedRecord" v-print="'#printContent'" v-else>打印</el-button>
                <el-button size="small" @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
export default {
    name: '',
    components: {},
    props: {
        isInit: {
            default: true,
            type: Boolean
        },
        printIds: {
            type: Array
        },
        printType: {
            type: Number,
            default: 0
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            listItemWidth: {
                width: '16.6%'
            },
            loading: true,
            userMsg: userMsg,
            allPrice: 0,
            allNum: 0,
            permission: {},
            isEditTitle: false, //编辑标题
            titleConfig: {}, //标题配置
            openTimeConfig: null, // 开单时间配置
            isEditOpenTime: false, // 编辑开单时间
            nameConfig: false,
            config: null, // 脚注配置
            isEditConfig: false, // 编辑脚注
            capitalAmount: '',
            imgUrl: '',
            sortField: 'sortnum', //排序
            isPrint: false,
            isPreview: false,
            isDefaultSet: false,
            orderData: {},
        };
    },
    watch: {
        orderData(value) {
            if (this.imgUrl) return;
            this.$nextTick(function () {
                try {
                    let canvas = this.$refs.canva;
                    QRCode.toCanvas(
                        canvas,
                        value.OrderCode,
                        {
                            width: 80,
                            height: 80,
                            margin: 0,
                            scrollX: 0,
                            scrollY: 0
                        },
                        function (error) {}
                    );

                    setTimeout(() => {
                        html2canvas(canvas, {
                            width: 80,
                            height: 80,
                            scrollX: 0,
                            scrollY: 0
                        }).then(canvasRes => {
                            var imgData = canvasRes.toDataURL('image/png');
                            this.imgUrl = imgData;
                            canvas.style.display = 'none';
                        });
                    }, 1000);
                } catch (e) {
                    //
                }
            });
        }
    },
    created() {},
    mounted() {
        if (this.isInit) {
            this.init();
        } else this.loading = false;
    },
    methods: {
        init() {
            this.permission = this.$util.getPermission('salesOrder');
            if (this.permission.仓位管理) {
                this.listItemWidth.width = '14.28%';
            } else {
                this.listItemWidth.width = '16.6%';
            }
            let sortField = this.$util.getLocalStorage('sale_print_' + this.userMsg.EmployeeId);
            if (sortField) this.sortField = sortField;
            this.getConfigByCodes().then(() => {
                this.getSaleOrder();
                if (this.printType == 1&&!this.isDefaultSet) {
                    document.addEventListener('keydown', this.handleKeyEvent_Print);
                }
            });
        },
        handleKeyEvent_Print(e) {
            let that = this;
            let currtPrint = document.querySelector('#printContent');
            //当打印弹窗关闭时载触发当前事件时移除监听
            if (!currtPrint || !currtPrint.parentElement || !currtPrint.parentElement.domInserted) {
                document.removeEventListener('keydown', this.handleKeyEvent_Print);
                return;
            }  
            if (that.loading || that.isEditConfig || that.isEditTitle) return;
            let key = window.event.keyCode;
            e.preventDefault();
            // 打印并继续开单(F1)
            if (key == 112) {
                document.removeEventListener('keydown', this.handleKeyEvent_Print);
                that.returnOrderList(true);
            }
            // 打印并返回列表(F2)
            else if (key == 113) {
                document.removeEventListener('keydown', this.handleKeyEvent_Print);
                that.continueToOrder();
            }
            // 返回列表(F3)
            else if (key == 114) {
                document.removeEventListener('keydown', this.handleKeyEvent_Print);
                that.returnOrderList(false);
            }
            return;
        },    
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['dyxssj', 'dyxs', 'dyshbt', 'dyywync', 'dyyl', 'syllqdysz'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            switch (code) {
                                case 'dyxssj':
                                    this.openTimeConfig = data[i];
                                    break;
                                case 'dyxs':
                                    this.config = data[i];
                                    break;
                                case 'dyshbt':
                                    this.titleConfig = data[i];
                                    break;
                                case 'dyywync':
                                    this.nameConfig = result;
                                    break;
                                case 'dyyl':
                                    this.isPreview = result;
                                    break;
                                case 'syllqdysz':
                                    this.isDefaultSet = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        lodopPrint() {
            let LODOP = this.$lodop.getLodop(); //调用getLodop获取LODOP对象
            if (LODOP) {
                let strBodyStyle = `<style>
                        .el-row {
                        margin-bottom: 0;
                        }
                        .print-title-view {
                        width: 762px;
                        position: relative;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-end;
                        padding: 12px 0;
                        }
                        .order-code {
                            width: 80px;
                            height: 80px;
                            display: inline-block;
                            vertical-align: top;
                        }

                        .qrcode-canvas,.qrcode-image{
                            display:none;
                        }
                        .order-detail {
                        color: #000;
                        }

                        .order-remark {
                        display: -webkit-flex;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        margin-left: 10px;
                        margin-right: 10px;
                        padding-top: 10px;
                        color: #000;
                        }
                        .order-setcontent {
                        padding: 0px 0px 15px 0px;
                        color: #000;
                        }
                        .print-title {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        max-width: 50%;
                        margin: 0 auto;
                        text-align: center;
                        font-size: 20px;
                        font-weight: bold;
                        color: #000;
                        min-height: 26px;
                        }
                        .dialog-footer {
                        display: -webkit-flex;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        margin-top: 20px;
                        }
                        .re-submit {
                        text-align: right;
                        }

                        .print-zone {
                        width: 200mm;
                        }

                        .print-table-main {
                        width: 762px;
                        font-size: 12px;
                        }
                        .div-table-cell {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            height: auto;
                            line-height: 30px;
                            padding-left: 10px;
                            border-top: 1px solid #000;
                            border-right: 1px solid #000;
                            border-bottom: 1px solid #000;
                            color: #000;
                        }
                        .div-table-row {
                            display: flex;
                            border-left: 1px solid #000;
                            margin: 0;
                            font-size: 14px;
                        }
                        
                        .fdzt {
                        font-size: 14px;
                        }
                        .sort-set {
                        margin-left: 10px;
                        }
                        .btn-primary {
                            background: #ff9900;
                            color: white;
                            margin-left: 0px;
                        }
                        .order-picking{
                            margin-right:80px;
                        }
                    </style>`;

                let strPrintHtml = strBodyStyle + '<body>' + document.getElementById('printContent').innerHTML + '</body>';

                LODOP.ADD_PRINT_BARCODE(10, 1, 100, 100, 'QRCode', this.orderData.OrderCode);
                //   LODOP.PRINT_INIT('打印小票')
                LODOP.SET_PRINT_STYLEA(0, 'QRCodeVersion', 3);
                LODOP.SET_PRINT_STYLEA(0, 'QRCodeErrorLevel', 'L');

                let contentHeight = document.getElementById('printContent').clientHeight;
                if (contentHeight <= 1080) {
                    LODOP.SET_PRINT_PAGESIZE(3, '210mm', '20mm', ''); // 这里3表示纵向打印且纸高“按内容的高度”；580表示纸宽58mm；45表示页底空白4.5mm
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '98%', strPrintHtml);
                } else {
                    LODOP.SET_PRINT_PAGESIZE(0, '210mm', '286mm', '');
                    // top,left,width,height,htmlContent
                    LODOP.ADD_PRINT_HTM('0', '0', '210mm', '98%', strPrintHtml);
                    LODOP.NEWPAGEA();
                }
                //选择操作系统中设为“默认”的打印机，“-1”代表默认打印机
                LODOP.SET_PRINTER_INDEX(-1);
                if (this.isPreview) LODOP.PREVIEW();
                //预览
                else LODOP.PRINT(); // 直接打印

                setTimeout(() => {
                    this.printedRecord();
                }, 1000);
            }
        },
        printedRecord() {
            this.loading = true;
            this.$util
                .printedRecord({ OrderId: this.printIds[0], Type: 0 }, false)
                .then(() => {
                    this.isPrint = true;
                    this.loading = false;
                    // this.closeDialog(true);
                    if (!this.isInit) this.$emit('closeDialog', true);
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        continueToOrder() {
            if (!this.isDefaultSet) {
                this.lodopPrint();
                setTimeout(() => {
                    this.$emit('closePrintDialog',"continueToOrder");
                }, 2000);
            } else {
                this.loading = true;
                this.$util
                    .printedRecord({
                            OrderId: this.printIds[0],
                            Type: 0
                        },true
                    )
                    .then(res => {
                        setTimeout(() => {
                            this.$emit('closePrintDialog',"continueToOrder");
                        }, 2000);
                    })
                    .catch(err => {
                        this.loading = false;
                    });
            }
        },
        returnOrderList(delay) {
            if (delay) {
                if (!this.isDefaultSet) {
                    this.lodopPrint();
                    setTimeout(() => {
                        this.$router.push('/salesManage/salesOrder');
                    }, 2000);
                } else {
                    this.loading = true;
                    this.$util
                        .printedRecord({
                                OrderId: this.printIds[0],
                                Type: 0
                            },true
                        )
                        .then(res => {
                            setTimeout(() => {
                                this.$router.push('/salesManage/salesOrder');
                            }, 2000);
                        })
                        .catch(err => {
                            this.loading = false;
                        });
                }
            } else {
                this.$router.push('/salesManage/salesOrder');
            }
        },
        // 取消
        cancel() {
            this.$emit('closeDialog', this.isPrint);
        },
        // 获取表格数据
        getSaleOrder() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetEntpCusSaleOrderPrint',
                    data: {
                        EntpCusOId: this.printIds[0],
                        SortField: this.sortField
                    },
                    hideLoading: this.isInit
                })
                .then(res => {
                    let _allNum = 0;
                    let _allPrice = 0;
                    let data = res.data;
                    this.orderData = res.data;
                    let DetailList = data.DetailList;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allPrice += DetailList[i].Count * DetailList[i].Price;
                    }
                    this.allNum = _allNum;
                    this.allPrice = _allPrice;
                    let total = (_allPrice + Number(data.ShipAmount) - Number(data.DiscountAmount)).toFixed(2);
                    if (total > 0) {
                        this.capitalAmount = this.$util.moneyToCapital(total);
                    }
                    let that = this;
                    if (that.isInit) that.loading = false;
                    else {
                        this.$nextTick(() => {
                            setTimeout(() => {
                                that.lodopPrint();
                            }, 100);
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        setOpenTime() {
            this.isEditOpenTime = true;
        },
        submitOpenTime() {
            this.isEditOpenTime = false;
        },
        //提交打印标题
        submitTitleConfig() {
            this.isEditTitle = false;
            this.$util.setSysConfigValue(this.titleConfig.ConfigId, this.titleConfig.RValue);
        },
        setConfig() {
            this.isEditConfig = true;
        },
        // 提交脚注
        submitConfig() {
            if (!this.config.RValue || !this.config.RValue.trim()) {
                this.$message.error('请输入脚注');
                return;
            }
            this.isEditConfig = false;
            this.$util.setSysConfigValue(this.config.ConfigId, this.config.RValue);
        },
        setSortField(field) {
            this.$util.setLocalStorage('sale_print_' + this.userMsg.EmployeeId, field);
            this.sortField = field;
            this.getSaleOrder();
        }
    }
};
</script>
<style lang="less" scoped media="print">
.el-row {
    margin-bottom: 0;
}
.print-title-view {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 12px 0;
    .qrcode-canvas,
    .qrcode-image {
        width: 80px;
        height: 80px;
        display: inline-block;
        vertical-align: top;
    }
}
.order-detail {
    color: #000;
}

.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding-top: 10px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
    min-height: 26px;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    position: relative;
}

.print-table-main {
    width: 792px;
    font-size: 12px;

    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
    }
    .pall-count {
        text-align: right;
    }
}
.fdzt {
    font-size: 14px;
}
.sort-set {
    margin-left: 10px;
    .btn-primary {
        background: #ff9900;
        color: white;
        margin-left: 0px;
    }
}
</style>
